import { Record, Map } from "immutable";
import moment from "moment";

const FormsRecord = Record({
  createTemplate: new (Record({
    disabled: false,
    isAddModalVisible: false,
    errors: new Map([]),
    isErrorVisible: new Map([]),
    fields: new (Record({
      name: "",
      slug: ""
    }))()
  }))(),
  createTemplateSection: new (Record({
    disabled: false,
    isAddModalVisible: false,
    errors: new Map([]),
    isErrorVisible: new Map([]),
    fields: new (Record({
      name: "",
      placeholder: "",
      sort: 1
    }))()
  }))()
});

// We can subclass FormRecord to add custom getters or methods.
export default class Forms extends FormsRecord {}



// WEBPACK FOOTER //
// ./src/common/templates/forms.js